import { map } from 'lodash';
import { path, assoc } from 'ramda';
import { createSelector } from 'reselect';
import { getBarbersFromFilterSorted } from '../../appointmentSelector';
import { getActiveShop } from '../../../../auth/selectors';


export const getCalendar = path(['appointments', 'sideBySide', 'calendar']);
export const getBlockedTimes = path(['appointments', 'sideBySide', 'blockedTimes']);
export const getSideBySideAppointments = path(['appointments', 'sideBySide', 'appointments']);
export const getLoadedDate = path(['appointments', 'sideBySide', 'loadedDate']);
export const getWorkday = path(['appointments', 'sideBySide', 'workday']);
export const getSideBySideAppointmentsForBarber = (state, props) =>
  path(['appointments', 'sideBySide', 'appointments', props.barber.id])(state);

export const getSideBySideApptsWithShopForBarber = () => createSelector(
  [getActiveShop, getSideBySideAppointmentsForBarber],
  (shop, appts) => map(appts, assoc('shop', shop)),
);

export const getBarbersForSideBySide = createSelector(
  [getBarbersFromFilterSorted, getSideBySideAppointments, getWorkday],
  (barbers, appointments, workdays) => barbers.filter(barber => workdays[barber.id] || appointments[barber.id])
);
